import React, { useEffect, useState } from 'react';
import HeaderFFF from '../../../components/HeaderFFF'
import Header from '../../../components/Header'
import Footer from '../../../components/Footer'
import { Link } from 'react-router-dom';
import '../../../styles/injury.css'

export default function PublicTransit() {
   const [isMobile, setIsMobile] = useState(window.innerWidth <= 1000);
   
       useEffect(() => {
           const handleResize = () => {
               setIsMobile(window.innerWidth <= 991);
           };
   
           window.addEventListener('resize', handleResize);
           return () => window.removeEventListener('resize', handleResize);
       }, []);
   
       return(
           <>
           {isMobile ? <Header /> : <HeaderFFF />}
        <div id="injury">
            <div id="fields-header-container">
                <svg xmlns="http://www.w3.org/2000/svg" width="102" height="2" viewBox="0 0 102 2" fill="none">
                    <path d="M101 1H1" stroke="#BF9874" stroke-width="2" stroke-linecap="round"/>
                </svg>
                <h2>Public Transit Injuries</h2>
                <svg xmlns="http://www.w3.org/2000/svg" width="102" height="2" viewBox="0 0 102 2" fill="none">
                    <path d="M101 1H1" stroke="#BF9874" stroke-width="2" stroke-linecap="round"/>
                </svg>
            </div>
            <div className="pi-go-back">
                        <Link to="/fields-of-expertise/personal-injury">Take me back</Link>
                </div>
            <div className="pi-text">
                <p>Accidents happen with streetcars, buses, and subways. When these accidents occur,
severe personal injuries are frequent. If you’re a passenger on public transit in the GTA, there is
nothing you can do to predict or prevent an accident, which makes you particularly vulnerable.
Public transit passengers can be sent flying through the air in an accident and collide with the
vehicle interior or other passengers making brain injuries and broken bones common.<br/><br/>
If you have suffered a <b>personal injury on public transit</b>, the transportation agency may be
liable and owe you compensation. However, transport agencies have skilled lawyers and

representatives to protect their interests and defend against liability. You need a
skilled personal injury lawyers team that knows how to deal with transport agencies and that
can ensure the compensation to which you are entitled.<br/><br/>
CLV, <b>a personal injury law firm in the GTA</b> has the expertise to fight for your rights and
represent your interests against transport agencies. Often, with the right representation, these
cases can be settled quickly outside of court, securing you the compensation you need for your
recovery.<br/><br/>
Whenever you are seeking compensation from a government organization, you need an
experienced personal injury lawyer who can keep you from being taken advantage of. The Team
at CVL knows how to handle these cases and protect your rights. We are equipped to handle
complex legal and insurance issues arising from your public transit accident.<br/><br/>
To arrange a Free consultation, <Link to="/contact-us">contact us</Link> today.</p>
            </div>
        </div>
            <Footer />
        </>
        );
}